import { getVariationFillColor } from '@gonfalon/flag-variations/getVariationFillColor';
import type { List, Map } from '@gonfalon/immutable-shim/immutableShim';
import clsx from 'clsx';

import { VARIATION_NOT_FOUND } from '#components/InstructionList/instructionListUtils';
import Variation from '#components/Variation';
import type { Variation as variationType } from '#utils/flags/records/Variation';

import styles from './styles.module.css';

const getVariationIndex = (variationID: string, variations: List<variationType>) =>
  variations.findIndex((v) => v._id === variationID);

export const RolloutDescription = ({
  contextKind,
  rolloutWeights,
  variations,
  bucketBy,
}: {
  contextKind?: string;
  rolloutWeights: Map<string, number>;
  variations: List<variationType>;
  bucketBy?: string;
}) => {
  const renderVariation = (index: number) => (
    <Variation
      className={clsx(styles.variationInstructionEntry, 'u-ml-s')}
      key={index}
      color={getVariationFillColor(index)}
      value={
        /* eslint-disable @typescript-eslint/no-non-null-assertion */
        variations.get(index)!.getDisplay() /* eslint-enable @typescript-eslint/no-non-null-assertion */
      }
    />
  );

  let i = 0;
  const length = rolloutWeights.size;
  const sortedRolloutWeights = rolloutWeights.sortBy((_value, variationID) => {
    const variationIndex = getVariationIndex(variationID, variations);
    if (variationIndex === -1) {
      return Infinity;
    }
    return variationIndex;
  });

  return (
    <span className={styles.RolloutDescription}>
      {sortedRolloutWeights
        .map((value: number, variationID: string) => {
          const variationIndex = getVariationIndex(variationID, variations);
          const displayedVariationIndex: number | string = variationIndex !== -1 ? variationIndex : VARIATION_NOT_FOUND;
          const percent = value / 1000;
          const additionalRolloutText = i++ !== length - 1 && ', ';
          return (
            <span key={variationID} className={styles.rolloutDescriptionItem}>
              {typeof displayedVariationIndex === 'number'
                ? renderVariation(displayedVariationIndex)
                : ` ${VARIATION_NOT_FOUND}`}
              <span className="u-ml-s">({percent}%)</span>
              {additionalRolloutText}
            </span>
          );
        })
        .valueSeq()}
      {bucketBy && ` bucketed by ${contextKind || 'context'} attribute ${bucketBy}`}
    </span>
  );
};
